import React, { ReactNode, useEffect, useRef } from "react";
import { createContext, useContext, useState } from "react";
import { initialSession, Auth } from "../IRequestModel/IAuthModel";
import { CheckForModule } from "../Services/AppSettingService";

interface AppSettingProviderProps {
  children: ReactNode;
}

type TModuleRequest = {
  requestable: boolean;
  viewReport: boolean;
};

interface IAppSettingtextType {
  muduleRequest: TModuleRequest;
}

export const AppSettingContext = createContext<IAppSettingtextType>({
  muduleRequest: {
    requestable: true,
    viewReport: true,
  },
});
export const useAppSettingContext = () => useContext(AppSettingContext);

export const AppSettingContextProvider: React.FC<AppSettingProviderProps> = (
  props
) => {
  const muduleRequest = useRef<TModuleRequest>({
    requestable: true,
    viewReport: true,
  });

  useEffect(() => {
    fecthAppSetting();
  }, []);

  const fecthAppSetting = async () => {
    const moduleRequest = await CheckForModule();
    muduleRequest.current = moduleRequest;
  };

  return (
    <AppSettingContext.Provider
      value={{ muduleRequest: muduleRequest.current }}
    >
      {props.children}
    </AppSettingContext.Provider>
  );
};
